import "core-js/modules/es6.function.name";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('slideUp', {
    model: {
      value: _vm.isSlideUp,
      callback: function callback($$v) {
        _vm.isSlideUp = $$v;
      },
      expression: "isSlideUp"
    }
  }, [_c('div', {
    staticClass: "welfare-list-box"
  }, [_c('div', {
    staticClass: "head-box"
  }, [_c('div', {
    staticClass: "my-reward",
    on: {
      "click": _vm.goMyTask
    }
  }, [_vm._v("我的奖励")]), _c('div', {
    staticClass: "list-title"
  }, [_vm._v("限时福利")]), _c('ycf-svg', {
    staticClass: "iconfont all_new_close_icon",
    attrs: {
      "icon-name": "all_new_close_icon"
    },
    on: {
      "click": function click($event) {
        _vm.isSlideUp = false;
      }
    }
  })], 1), _c('div', {
    staticClass: "task-list"
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.dataList.length,
      expression: "dataList.length"
    }],
    staticClass: "list-content"
  }, _vm._l(_vm.dataList, function (item, index) {
    return _c('li', {
      key: index,
      staticClass: "hotel-scenic",
      class: {
        default: item.type == 2 && item.playMode == 1,
        head: item.type == 2 && item.playMode == 2,
        new: item.type == 3,
        rank: item.type == 1,
        tool: item.type == 4
      },
      on: {
        "click": function click($event) {
          return _vm.goTaskDetails(item);
        }
      }
    }, [_c('div', {
      staticClass: "content-info"
    }, [_c('p', {
      staticClass: "info-title"
    }, [_vm._v(_vm._s(item.name))]), _c('p', {
      staticClass: "info-reward-desc",
      domProps: {
        "innerHTML": _vm._s(item.describe)
      }
    }), _c('p', {
      staticClass: "info-desc"
    }, [_vm._v(_vm._s(item.timeDesc.describe))])]), _c('div', {
      staticClass: "btn-box",
      class: {
        'recieving': item.hasRecTask && item.completionLevel > item.receiveLevel && !item.timeDesc.isEnd,
        'all-done': item.type == 2 && item.hasRecTask && item.totalLevel == item.completionLevel
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.takeTask(item);
        }
      }
    }, [_c('button', {
      staticClass: "task-btn",
      class: {
        'no-recieve': !item.hasRecTask,
        'disabled': item.status == 2 || !item.canRecTask && !item.hasRecTask && item.type != 1 && item.type != 4,
        'end': item.timeDesc.isEnd
      }
    }, [_vm._v(_vm._s(item.btnTxt))]), item.type == 2 && item.hasRecTask && item.completionLevel < item.totalLevel && !item.timeDesc.isEnd ? _c('p', {
      staticClass: "task-progress"
    }, [_vm._v("已完成"), _c('span', [_vm._v(_vm._s(item.completionLevel) + "/" + _vm._s(item.totalLevel))])]) : _vm._e()])]);
  }), 0), _c('ycf-download-tips', {
    attrs: {
      "visible": _vm.dialogShowed,
      "type": "1",
      "linkStr": "GriG1D"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogShowed = $event;
      }
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.dataList.length,
      expression: "!dataList.length"
    }],
    staticClass: "empty-content"
  }, [_c('img', {
    attrs: {
      "src": "https://qiniu-cdn7.jinxidao.com/dvb/frontv2/images/illustration.png"
    }
  }), _c('p', [_vm._v("暂无数据")])])], 1)])]), _c('yLayer', {
    attrs: {
      "layer-data": _vm.welfareSuccessData
    },
    on: {
      "diaLogStatus": _vm.diaLogStatus
    }
  }, [_c('template', {
    slot: "header"
  }, [_c('ycf-image', {
    staticClass: "top-image",
    attrs: {
      "src": "/srcv2/images/task_box_grain.png"
    }
  })], 1), _c('template', {
    slot: "body"
  }, [_c('div', {
    staticClass: "welfare-box"
  }, [_c('ycf-svg', {
    staticClass: "iconfont all_new_close_icon",
    attrs: {
      "icon-name": "all_new_close_icon"
    },
    on: {
      "click": _vm.closeWelfarePop
    }
  }), _c('p', {
    staticClass: "title"
  }, [_vm._v("限时福利")]), _c('p', {
    staticClass: "desc"
  }, [_vm._v("该产品正在参加限时推广活动，一大波福利来袭，现金、红包奖不停！")]), _c('button', {
    on: {
      "click": _vm.showWelfareList
    }
  }, [_vm._v("立即查看")])], 1)])], 2)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };